export default __webpack_public_path__ + "static/media/uploadDoc.81794192.svg";